import { get, post, put, getPreBookings } from '@services/company/companyDataService';
import companyStoreActions from '@constans/store/company/companyStoreActions';
import companyStoreMutations from '@constans/store/company/companyStoreMutations';
import borderMutations from '@constans/store/border/borderMutations';
const actions = {
    [companyStoreActions.GET]: async ({ commit, rootState }, payload) => {
        const result = await get(payload).then((response) => {
            if (response.status === 'Success') {
                if (payload) {
                    commit(companyStoreMutations.SET_PAYLOAD, response.data);
                    if (rootState.border.borders.length > 0) {
                        const findFirstBorder = response.data.border_ids[0];
                        rootState.border.borders.forEach((border) => {
                            if (border.children) {
                                const parentId = border.children.find((c) => c.id === findFirstBorder)?.parent_id || findFirstBorder;
                                commit(`border/${borderMutations.SET_PARENT_ID}`, parentId, { root: true });
                            }
                        });
                    }
                }
                else {
                    commit(companyStoreMutations.SET_TENANTS, response.data);
                }
            }
        });
        return result;
    },
    [companyStoreActions.POST]: async ({ state, commit }) => {
        const result = await post(state.tenant_payload).then((response) => {
            if (response.status === 'Success') {
                commit(companyStoreMutations.RESET_PAYLOAD);
                return response;
            }
        });
        return result;
    },
    [companyStoreActions.PUT]: async ({ state }) => {
        const result = await put(state.tenant_payload).then((response) => {
            if (response.status === 'Success') {
                return response;
            }
        });
        return result;
    },
    [companyStoreActions.TOGGLE_AREAS]: async ({ commit }, ids) => {
        // Commit and update company state
        commit(companyStoreMutations.SET_AREA, ids);
    },
    [companyStoreActions.GET_PRE_BOOKINGS]: async ({ commit }) => {
        const result = await getPreBookings().then(response => {
            if (response.status === 'Success') {
                commit(companyStoreMutations.SET_PRE_BOOKINGS, response.data);
            }
            return response.status === 'Success';
        });
        return result;
    }
};
export default actions;
